import {all, call, fork, put, takeLatest} from 'redux-saga/effects';

import {ClassroomApi, TeacherApi} from 'static/three-oh/src/modules/apis';

import * as actions from '../actions/schoolChangeActions';
import * as types from '../constants/schoolChangeActionTypes';


export function * archiveClassrooms(classrooms) {
  yield all(
    classrooms.map((classroom) =>
      call(ClassroomApi.archiveClassroom, classroom?.id, classroom)
    )
  );
}


export function * removeUserSchool(user) {
  /**
   * Remove the teacher's preferred school
   */
  const teacher = user?.teacher;
  const payload = {...teacher};
  payload.school = null;
  payload.school_id = null;

  yield call(TeacherApi.persistTeacher, payload);
}

export function * changeUserSchool(payload) {
  try {
    const {user, classrooms} = payload;

    yield archiveClassrooms(classrooms);
    yield removeUserSchool(user);

    yield put(actions.getSchoolChangeSuccess());
  } catch (error) {
    yield put(actions.getSchoolChangeFailure(error));
  }
}

export function * watchRemoveUserSchool() {
  yield takeLatest(types.INITIALIZE_CHANGE_SCHOOL_REQUEST, function * init(action) {
    yield fork(changeUserSchool, action.payload);
  });
}
